export const UNKNOWN_PLANNED_AMOUNT_LABEL = "Kwota do ustalenia";

function positiveMoney(value) {
  if (value === "" || value === null || value === undefined) return null;
  const normalized = Number(String(value).trim().replace(",", "."));
  if (!Number.isFinite(normalized) || normalized <= 0) return null;
  return Math.round((normalized + Number.EPSILON) * 100) / 100;
}

export function getKnownPlannedAmount(expense = {}) {
  return (
    positiveMoney(expense.amount) ??
    positiveMoney(expense.estimated_amount) ??
    null
  );
}

export function isActivePlannedExpense(expense = {}) {
  return expense.status !== "Zrealizowane" && expense.status !== "Anulowane";
}

export function getActivePlannedExpenses(expenses = []) {
  return expenses.filter(isActivePlannedExpense);
}

export function parseOptionalPlannedAmount(value) {
  if (value === "" || value === null || value === undefined) return null;
  return positiveMoney(value);
}

export function buildPlannedExpenseMutation(form = {}) {
  const amount = parseOptionalPlannedAmount(form.amount);
  return {
    occasion: String(form.occasion ?? "").trim(),
    planned_date: form.planned_date || null,
    amount,
    // Legacy NOT NULL column remains compatible, while zero keeps "unknown"
    // distinguishable from every real positive amount.
    estimated_amount: amount ?? 0,
    amount_per_child: parseOptionalPlannedAmount(form.amount_per_child),
    description: String(form.description ?? "").trim() || null,
    status: form.status || "Planowane",
  };
}

export function plannedExpenseToForm(expense = {}) {
  return {
    occasion: expense.occasion ?? expense.name ?? "",
    planned_date: expense.planned_date ?? "",
    amount: getKnownPlannedAmount(expense) ?? "",
    amount_per_child: positiveMoney(expense.amount_per_child) ?? "",
    description: expense.description ?? "",
    status: expense.status ?? "Planowane",
  };
}

export function sortActivePlannedExpenses(expenses = []) {
  return getActivePlannedExpenses(expenses)
    .map((expense, index) => ({ expense, index }))
    .sort((left, right) => {
      const leftDate = left.expense.planned_date || null;
      const rightDate = right.expense.planned_date || null;
      if (leftDate && rightDate && leftDate !== rightDate) {
        return leftDate.localeCompare(rightDate);
      }
      if (leftDate && !rightDate) return -1;
      if (!leftDate && rightDate) return 1;
      return left.index - right.index;
    })
    .map(({ expense }) => expense);
}
